

































































import {
  computed,
  defineComponent,
  reactive,
  ref,
  watch,
} from '@vue/composition-api';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';
import { useFormat } from 'vivat';
import PrettyCheck from 'pretty-checkbox-vue/check';

import useAuth from '@/useAuth';

import getInvoice from '@/gql/invoice/getInvoice.gql';
import createInvoice from '@/gql/invoice/createInvoice.gql';
import updateInvoice from '@/gql/invoice/updateInvoice.gql';

import CommonSelectWithCompanyList from '@/components/Invoice/CommonSelectWithCompanyList.vue';
import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import usePayment from '@/usePayment';
import useInvoiceStatus from '@/useInvoiceStatus';

const CommonFormWithInvoiceEditor = defineComponent({
  components: {
    PrettyCheck,
    CommonSelectWithCompanyList,
    CommonModalWithPreset,
  },
  props: {
    id: { type: Number, default: -1 },
    deliveries: { type: Array },
  },
  setup(props, { emit }) {
    const NOW = useFormat.date().computerShortDate();
    const { me } = useAuth();
    const { th, en } = usePayment();
    const { DEFAULT_INVOICE } = useInvoiceStatus();
    const invoice = reactive({ ...DEFAULT_INVOICE });

    const toggleStatusSelect = (event: any) => {
      const status = event ? 'PAID' : 'UNPAID';
      invoice.status = status;
    };

    const invoiceStatusDropdown = ['UNPAID', 'PAID'];

    const modal = ref(null);

    const open = () => {
      (modal.value as any).open();
    };
    const close = () => {
      (modal.value as any).close();
    };

    const { result: invoiceResult, loading } = useQuery(getInvoice, computed(() => ({
      id: props.id,
    })));
    const _invoice = useResult(invoiceResult, {}, (data) => data.invoice);
    watch(() => _invoice.value, (newVal, oldVal) => {
      if (props.id !== -1 && !loading.value && newVal !== oldVal) {
        invoice.id = _invoice.value.id;
        invoice.code = _invoice.value.code;
        // invoice.date = _invoice.value.date;
        invoice.dueDate = _invoice.value.dueDate;
        invoice.type = _invoice.value.type;
        invoice.remarks = _invoice.value.remarks;
        invoice.status = _invoice.value.status;
        invoice.discount = _invoice.value.discount;
        invoice.companyId = _invoice.value.debtor.id;
      } else {
        invoice.id = -1;
        invoice.code = '';
        // invoice.date = NOW;
        invoice.dueDate = NOW;
        invoice.type = '';
        invoice.remarks = '';
        invoice.status = '';
        invoice.companyId = '';
        invoice.discount = 0;
      }
    });

    const refetchQueries = ['getInvoices', 'getDeliveries', 'getInvoiceStats'];
    const invoiceInput = computed(() => ({
      id: props.id === -1 ? undefined : props.id,
      code: props.id === -1 ? invoice.code : undefined,
      // date: useFormat.date(invoice.date).computerShortDate(),
      dueDate: useFormat.date(invoice.dueDate).computerShortDate(),
      type: invoice.type,
      remarks: invoice.remarks,
      status: props.id === -1 ? 'UNPAID' : invoice.status,
      discount: invoice.discount,
      deliveries: props.id === -1 ? { connect: props.deliveries } : undefined,
      createdBy: props.id === -1 ? { connect: me.id } : undefined,
      debtor: { connect: (invoice.companyId as any)?.id },
    }));

    const createInvoiceMutation = useMutation(createInvoice, () => ({
      variables: {
        input: invoiceInput.value,
      },
      refetchQueries,
    }));
    const updateInvoiceMutation = useMutation(updateInvoice, () => ({
      variables: {
        input: {
          ...invoiceInput.value,
          code: undefined,
          delivery: undefined,
          createdBy: undefined,
        },
      },
      refetchQueries,
    }));
    const computedMutation = computed(() => {
      if (props.id !== -1) return updateInvoiceMutation;
      return createInvoiceMutation;
    });

    const confirmModal = ref(null);
    createInvoiceMutation.onDone(() => {
      emit('done');
      (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'สำเร็จ' });
    });
    updateInvoiceMutation.onDone(() => {
      emit('done');
      (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'สำเร็จ' });
    });
    const errorModal = ref(null);
    createInvoiceMutation.onError(() => {
      emit('done');
      (errorModal.value as any).compose();
    });
    updateInvoiceMutation.onError(() => {
      emit('done');
      (errorModal.value as any).compose();
    });

    return {
      invoice,
      invoiceDisplay: th,
      invoiceList: en,
      invoiceStatusDropdown,

      invoiceInput,

      modal,
      confirmModal,
      errorModal,
      open,
      close,

      computedMutation,

      toggleStatusSelect,
    };
  },
});

export default CommonFormWithInvoiceEditor;
